module.exports = __webpack_public_path__ + "static/img/Parametric Studies 2 - Parametrical missions.2f706aa.png";